import parse from 'html-react-parser';

interface Props {
  content: string;
  className?: string;
}

const Paragraph = ({ content, className }: Props) => {
  return <div className={className}>{parse(content)}</div>;
};

export default Paragraph;
